import * as React from "react";
const SvgGripLines = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 10.75H5V9.25H19V10.75ZM19 14.75H5V13.25H19V14.75Z", fill: "currentColor" }));
export default SvgGripLines;
